(function() {
  'use strict';

  angular
    .module('service.quiz')
    .factory('PreviewQuizService', PreviewQuizService);

  PreviewQuizService.$inject = ['$http', 'ServiceHelper', '$window'];

  function PreviewQuizService($http, ServiceHelper, $window) {
    var url = {
      answer: 'https://:host/:ipad/gaviota-api/trainer/cModule/:cModuleId/quiz/:quizId/question/:questionId'
    };

    var keys = ['ipad', 'cModuleId', 'action', 'userId'];

    function createUrl(baseUrl, data) {
      return keys.reduce(function(url, key) {
        return url.replace(new RegExp('/:' + key), '');
      }, Object.keys(data).reduce(function(url, key) {
        var value = data[key]
        return url.replace(new RegExp('/:' + key), value ? '/' + data[key] : '');
      }, baseUrl));
    }

    function respond(promise, resultCb, errorCb) {
      return promise.then(function(response) {
        resultCb = resultCb || angular.noop;
        return resultCb(response.data);
      }, function(response) {
        return ServiceHelper.errorHandler(errorCb || angular.noop)(response);
      });
    }

    var service = {
      answerQuestion: answerQuestion,
      submitQuiz: submitQuiz
    };

    return service;

    function answerQuestion(params, resultCb, errorCb) {
      var urlParams = _.extend(ServiceHelper.defaultUrlParams(), {
        cModuleId: params.cModuleId,
        quizId: params.quizId,
        questionId: params.questionId
      });

      return ServiceHelper.checkCanCallService(function() {
        return respond($http.post(createUrl(url.answer, urlParams), params),
          resultCb, errorCb);
      });
    }

    function submitQuiz(submitQuizRequest, resultCb, errorCb) {
      return resultCb();
    }
  }
})();
